import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    dsn: "https://f8ec85af8b0244bca7d4a547d9d19e38@o90177.ingest.sentry.io/5455615",
    release: "gann@" + process.env.npm_package_version,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0, // We recommend adjusting this in production
});
